// extracted by mini-css-extract-plugin
export var cardIcon = "_9u-4";
export var checkboxCard = "_9u-0";
export var checkboxCardSelected = "_9u-3";
export var disabled = "_9u-1";
export var outerBorder = "_9u-2";
export var spacerMedium = "_9u-7";
export var spacerSmall = "_9u-6";
export var spacerXsmall = "_9u-5";